const VERSION_KEY = 'app_version';

export function checkAndHandleVersionUpdate(): void {
  const currentVersion = __APP_VERSION__;
  const storedVersion = localStorage.getItem(VERSION_KEY);

  if (storedVersion !== null && storedVersion !== currentVersion) {
    console.log(`[Version] New version detected: ${currentVersion} (was ${storedVersion}). Clearing caches and reloading.`);

    // Clear all browser caches (same as Angular clearCache())
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    // Save new version before reload to prevent reload loop
    localStorage.setItem(VERSION_KEY, currentVersion);
    window.location.reload();
    return;
  }

  // First visit or version already current — just persist it
  localStorage.setItem(VERSION_KEY, currentVersion);
}
